import { MetabaseReport } from '@stylehaven/components';

import { Comparable } from '../../record/entities/misc/comparable.interface';
import { Trackable } from '../../record/entities/misc/trackable.interface';

export class ReportRow implements Comparable, Trackable {
    readonly key: string;
    readonly naam: string;

    constructor(report: MetabaseReport) {
        this.key = `${report.Id}`;
        this.naam = report.Label;
    }

    equals(other: any): boolean {
        return other instanceof ReportRow && other.key === this.key;
    }

    trackBy(): string {
        return this.key;
    }
}
